var map = {
	"./Basis.vue": "b1de",
	"./CustomFields.vue": "5469",
	"./Devtools.vue": "f82b",
	"./Integration.vue": "0d09",
	"./PostCollection.vue": "9000",
	"./Presentation.vue": "fa8c",
	"./Publishing.vue": "e901",
	"./Role.vue": "5c33",
	"./Theme.vue": "3400"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ef59";